// @ts-nocheck
import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../hooks/useRedux";
import { blockUser, getBlockedUsersList } from "../store/userSlice";
import { fetchAllPublicPosts } from "../store/postsSlice";
import { BASE_URL } from "../Constants/BaseUrl";
import { ArrowLeft } from "lucide-react";

const perPage = 10;

interface BlockedUser {
  user_id: number;
  username: string;
  profile_picture: string;
  role: string;
  first_name: string;
  last_name: string;
  created_at: string;
}

interface UserState {
  blockedUsers: BlockedUser[] | null;
  loading: boolean;
  error: string | null;
}

const BlockedUsers: React.FC = () => {
  const dispatch = useAppDispatch();
  const { blockedUsers, loading, error } = useAppSelector(
    (state: { user: UserState }) => state.user,
  );

  useEffect(() => {
    dispatch(getBlockedUsersList())
      .unwrap()
      .then((response) => {
        console.log(
          "Blocked users response:",
          JSON.stringify(response, null, 2),
        );
      })
      .catch((err) => {
        console.error("Error fetching blocked users:", err);
      });
  }, [dispatch]);

  const handleUnblock = (userId: number) => {
    dispatch(blockUser({ userId }))
      .unwrap()
      .then((response) => {
        console.log("Unblock response:", response);
        dispatch(getBlockedUsersList());
        dispatch(fetchAllPublicPosts());
      })
      .catch((err) => {
        console.error("Error unblocking user:", err);
      });
  };

  const renderBlockedUser = ({
    item,
    index,
  }: {
    item: BlockedUser;
    index: number;
  }) => (
    <div
      className={`flex items-center py-2 px-4 border-b border-gray-700 ${
        index === (blockedUsers?.length ?? 0) - 1 ? "border-b-0" : ""
      }`}
    >
      <img
        // src={`${BASE_URL}/${item.profile_picture}`}
        src={
          item.profile_picture?.startsWith("https")
            ? item.profile_picture
            : item.profile_picture
              ? `${BASE_URL}/${item.profile_picture}`
              : undefined
        }
        alt="Profile"
        className="w-12 h-12 rounded-full mr-4"
        onError={(e) => {
          e.currentTarget.src =
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQfj3Bm37Nn_rBQHkIzxnpmGMv3AnLWNYvA1_GwXzebfQ7rxLHl0fRsKo6mIi1SmoOiCL4&usqp=CAU";
        }}
      />
      <div className="flex-1">
        <p className="text-base font-sans text-white">
          {`${item.first_name} ${item.last_name}`}
        </p>
        <p className="text-sm font-sans opacity-70 text-gray-300">
          {item.role}
        </p>
      </div>
      <button
        className="py-1 px-4 rounded bg-red-600 text-white"
        onClick={() => handleUnblock(item.user_id)}
      >
        Unblock
      </button>
    </div>
  );

  return (
    <div className="min-h-screen p-4 bg-black">
      <div className="relative flex items-center justify-center">
        <button
          className="absolute left-0 p-2"
          onClick={() => window.history.back()}
        >
          <ArrowLeft className="w-6 h-6 text-white" />
        </button>
        <h1 className="text-xl font-bold uppercase text-center text-white">
          Blocked Users
        </h1>
      </div>

      {loading && (
        <div className="mt-5 flex justify-center">
          <div className="animate-spin h-8 w-8 border-4 border-t-transparent rounded-full border-white"></div>
        </div>
      )}

      {error && (
        <p className="text-center text-base mt-5 text-white">{error}</p>
      )}

      {blockedUsers && blockedUsers.length > 0 ? (
        <div className="mt-4">
          {blockedUsers.map((item, index) => (
            <div key={item.user_id}>{renderBlockedUser({ item, index })}</div>
          ))}
        </div>
      ) : (
        !loading && (
          <p className="text-center text-base mt-5 text-white">
            No blocked users found.
          </p>
        )
      )}
    </div>
  );
};

export default BlockedUsers;
